module.exports = __webpack_public_path__ + "img/login_bg.ba9f772b.png";